import _ from 'lodash';
import LocalStorageService from './base.localstorage';
import CookieService from './base.cookie';


let storeService = LocalStorageService;
if (!_.has(window, `window.MbApi.file`)) {
    storeService = CookieService;
}

export default storeService;